export enum SchedulingServiceSessionType {
  VIRTUAL = 'virtual',
  HYBRID = 'hybrid',
  IN_PERSON = 'in_person',
}
